<template>
  <Modal v-model="isShowModal" :closable="false" :title="modalTitle" @on-ok="ok">
    <div style="margin: 25px">{{ modalBody }}</div>
  </Modal>
</template>

<script>
import { mapActions } from "vuex";

const CONFIGS = {
  out: {
    title: "转出提示",
    body: "此操作不可逆，是否继续操作？",
    successMsg: "转出成功",
    action: "assetTransferOut",
  },
  clearService: {
    title: "清空服务费提示",
    body: "将清空该公司的服务费余额，此操作不可逆，是否继续？",
    successMsg: "清空服务费成功",
    action: "assetClearService",
  },
  transferOutAll: {
    title: "一键转出提示",
    body: "将清空所有公司的资产，有冻结的公司会被跳过。此操作不可逆，是否继续？",
    successMsg: "一键转出完成",
    action: "assetTransferOutAll",
  },
};

export default {
  data() {
    return {
      isShowModal: false,
      actionType: "out",
      company_id: 0,
    };
  },
  computed: {
    cfg() {
      return CONFIGS[this.actionType] || CONFIGS.out;
    },
    modalTitle() {
      return this.cfg.title;
    },
    modalBody() {
      return this.cfg.body;
    },
  },
  methods: {
    ...mapActions({
      assetTransferOutAction: "assetTransferOut",
      assetClearServiceAction: "assetClearService",
      assetTransferOutAllAction: "assetTransferOutAll",
    }),
    open(actionType, company_id = 0) {
      this.actionType = actionType;
      this.company_id = company_id;
      this.isShowModal = true;
    },
    ok() {
      const employer_id = localStorage.getItem("employer_id");
      const actionMap = {
        out: () => this.assetTransferOutAction({ employer_id, company_id: this.company_id }),
        clearService: () => this.assetClearServiceAction({ employer_id, company_id: this.company_id }),
        transferOutAll: () => this.assetTransferOutAllAction({ employer_id }),
      };
      const action = actionMap[this.actionType] || actionMap.out;
      action()
        .then((msg) => {
          if (this.actionType === "transferOutAll" && msg && typeof msg === "object") {
            const skippedCount = (msg.skipped || []).length;
            const clearedCount = (msg.cleared || []).length;
            let tip = `共处理 ${msg.total} 家, 已清零 ${clearedCount} 家`;
            if (skippedCount > 0) {
              tip += `, 跳过 ${skippedCount} 家 (含冻结/空余额)`;
            }
            this.$Message.success(tip);
          } else {
            this.$Message.success(this.cfg.successMsg);
          }
          this.$parent.$parent.refresh();
          this.isShowModal = false;
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
  },
};
</script>

<style scoped>
.asset-out-modal-root-container {
  display: flex;
  flex-direction: column;
  padding: 25px 50px 30px 50px;
}
</style>
